import React, {useState} from "react";
import { connect } from "react-redux";
import HomeLayout from "../../Components/ehealth/Layout";
import { routers } from "../../Constants/routers";
import { SectionPage } from "./SectionPage";

const HomePage = () => {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

  return (
    <HomeLayout isHome={true}>
      <div className="hero is-fullheight has-video is-grey is-bold">
        <video
          className="hero-video-player"
          playsInline
          autoPlay
          muted
          loop
          poster={require("../../assets/images/pexels-ivan-samkov.jpg").default}
          data-demo-poster={
            require("../../assets/images/pexels-ivan-samkov.jpg").default
          }
        >
          <img
            src={require("../../assets/images/pexels-ivan-samkov.jpg").default}
          />
        </video>
        <div className="hero-overlay" />
        <div className="hero-body">
          <div className="container">
            <div className="columns is-vcentered">
              <div className="column is-12">
                <div className="hero-text is-light has-text-centered">
                  <h1 className="title is-1 is-bold">
                    24Telemed eConsult Services
                  </h1>
                  <p className="subtitle">
                    Secure telemedicine platform for specialists and patients.
                  </p>
                  <div className="has-text-centered">
                    <a
                      className="button is-primary mx-1 mb-3"
                      href="https://personnel-connect.24telemed.org"
                    >
                      Consult a specialist now
                    </a>
                    <a
                      className="button is-heavy mx-1"
                      href="https://doctor-connect.24telemed.org"
                    >
                      Doctor Login
                    </a>
                    <a
                      className={"button is-primary mx-1"}
                      onClick={handleModalOpen}
                    >
                      Register Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       {/* Modal Component */}
       {isModalOpen && (
        <div className="modal is-active">
          <div className="modal-background" onClick={handleModalClose}></div>
          <div className="modal-card">
            <header className="modal-card-head">
              <p className="modal-card-title"
              style={{
                fontSize: window.innerWidth <= 768 ? "0.75rem" : window.innerWidth <= 1024 ? "1rem" : "1.2rem",
                whiteSpace: "normal",
                textAlign: "left",
                padding: "0.5rem",
                lineHeight: "1.2",
              }}
              >
                Please contact the administrator to set up a new account.</p>
              <button className="delete" aria-label="close" onClick={handleModalClose}></button>
            </header>
            <section className="modal-card-body">
            <p>Email: info@24telemed.org</p>
              <p>Phone: +2348130790883, +2348107222448, +2349024000024</p>
              
            </section>
            <footer className="modal-card-foot">
              <button className="button is-primary" onClick={handleModalClose}>Close</button>
            </footer>
          </div>
        </div>
      )}
      <SectionPage />
    </HomeLayout>
  );
};

const mapStateToProps = ({ categories }) => {
  return { categories };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);